import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useMeta() {
  return useQuery({
    queryKey: ["meta"],
    queryFn: async () => (await api.get("/meta")).data,
    staleTime: Infinity,
  });
}
